import { render, staticRenderFns } from "./GlobalForm.vue?vue&type=template&id=70cef4c6&scoped=true"
import script from "./GlobalForm.vue?vue&type=script&lang=js"
export * from "./GlobalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cef4c6",
  null
  
)

export default component.exports